/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type UserStatusChangeContainer_settings = {
    readonly organization: {
        readonly name: string;
    };
    readonly multisite: boolean;
    readonly " $refType": "UserStatusChangeContainer_settings";
};
export type UserStatusChangeContainer_settings$data = UserStatusChangeContainer_settings;
export type UserStatusChangeContainer_settings$key = {
    readonly " $data"?: UserStatusChangeContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"UserStatusChangeContainer_settings">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserStatusChangeContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "multisite",
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any;
(node as any).hash = '825c7f07bc0a1e5d07592e0114c68c54';
export default node;
